import { createFormulaReadContext } from '../compile/formula-read-context';
import { readLayerListEntryUuid } from '../compile/inventory-raw-readers';
import { createVitalityReader } from '../compile/vitality-reader';
import { resolveObjectVitality } from './object-vitality';
import { geometrySizeId, sizeBandUpdates } from './transform-edit';

type Row = Record<string, unknown>;
const read = createFormulaReadContext({ catalogRows: {}, abilityTypes: [], aggregationStrategy: () => 'host_wins',
    resolveCarrierRef: () => null, resolveInventoryInstance: () => null });
const vitality = createVitalityReader({ resolveInventoryInstance: () => null });
export type ObjectSizeColumns = { inventory_size: string; v_max?: number; v_current?: number };

/** The shared definition result supplies defaults below the lean instance's own columns. */
export function planObjectSize(row: Row | null, template: Row | null, size: string): ObjectSizeColumns {
    if (!template || template._entity_refusal) throw new Error('item-compile:definition-unavailable');
    const defaults = vitality(template) as Row | null;
    const current = row ? resolveObjectVitality(row, null, () => template) : null;
    const update = sizeBandUpdates({
        vMax: current ? Number(current.base_v_max ?? current.v_max ?? 0) : null,
        vCurrent: current ? Number(current.base_v_current ?? current.v_current ?? 0) : null,
    }, size, { sizeId: readLayerListEntryUuid(read.layerValue(template, 'size')),
        vMax: Number(defaults?.base_v_max ?? defaults?.v_max ?? 0) });
    return { inventory_size: update.inventorySize,
        ...(update.vMax === undefined ? {} : { v_max: update.vMax, v_current: update.vCurrent }) };
}

/** Accepted cloth and rod dimensions, independent of the gathered/open pose. */
export function curtainDimensionBounds(opening: { span: { min: number; max: number }; z: { min: number; max: number } }): number[] {
    const width = opening.span.max - opening.span.min, height = opening.z.max - opening.z.min;
    if (!(width > 0 && height > 0)) throw new Error('invalid_curtain_dimensions');
    return [1.8519999980926514 * width * .3048 / 1.36,
        1.5921004191040993 * (height + .4) * .3048 / 1.49, .2230117917060852];
}

export function planCurtainSize(row: Row | null, template: Row | null,
    opening: Parameters<typeof curtainDimensionBounds>[0]): ObjectSizeColumns {
    const size = geometrySizeId(curtainDimensionBounds(opening), 1);
    if (!size) throw new Error('item-compile:resize-plan-unavailable');
    return planObjectSize(row, template, size);
}
